<template>
  <div class="h-full bg-blue-500 text-white text-center flex items-center flex-col justify-center">
    <div>
      <div style="font-size: 30vh">
        404
      </div>

      <div
        class="text-xl"
        style="opacity:.4"
      >
        Oops. Nothing here...
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ErrorPage',
});
</script>
